// src/app/onglets.js — les groupes d'onglets sous les chromes de l'admin.
// Déplacés à l'identique depuis src/App.jsx (P-3.5, squelette).

// Lot 5 (rangement Argent) — les onglets qui vivent sous le chrome € Argent.
// stats-admin = l'écran Statistiques refondu à deux modèles (lot Statistiques
// 2026-09 : conciergerie commission / sous-location marge, jamais mélangés).
const ARGENT_TABS = { donnees: 1, facturation: 1, historique: 1, compta: 1, 'stats-admin': 1 }

// Lot 6 (Voyageurs) — les onglets sous le chrome ✉ Voyageurs.
const VOYAGEURS_TABS = { messages: 1, 'voyageurs-textes': 1, 'voyageurs-avis': 1, 'voyageurs-demandes': 1 }

export { ARGENT_TABS, VOYAGEURS_TABS }
